module.exports = {
      id: "angle-up-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#angle-up",
      toString: function () {
        return this.url;
      }
    }